import React, { useEffect, useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronRight, faClock } from '@fortawesome/free-solid-svg-icons'
import { MiniWrapper } from './styles'
import { hasActiveOnboardingPackageRequest } from 'src/helpers/onboardingPackage'

type Props = {
  isVisible: boolean
  onClick: () => void
}

export default function OnboardingPackageMiniPanel({ isVisible, onClick }: Props) {
  const [hasSubmitted, setHasSubmitted] = useState(() => hasActiveOnboardingPackageRequest())

  useEffect(() => {
    const update = () => {
      setHasSubmitted(hasActiveOnboardingPackageRequest())
    }
    window.addEventListener('onboarding-package-submitted', update)
    return () => {
      window.removeEventListener('onboarding-package-submitted', update)
    }
  }, [])

  return (
    <MiniWrapper $isVisible={isVisible} onClick={onClick}>
      <div className="label">
        {!hasSubmitted && <span className="badge">NOU</span>}
        <span>{hasSubmitted ? 'Digitalizare Meniu - în curs' : 'Digitalizare Meniu'}</span>
      </div>
      <FontAwesomeIcon icon={hasSubmitted ? faClock : faChevronRight} />
    </MiniWrapper>
  )
}
